module.exports = __webpack_public_path__ + "img/undraw_Having_fun_re_vj4h.8ea517e0.svg";